export const formStructure = [
  [
    {
      name: 'nomeMotivo',
      label: 'Nome do Motivo',
      placeholder: 'Digite o nome do motivo',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
      required: true,
      maxLength: 120,
      validation: { required: 'Nome do motivo é obrigatório' },
    },
    {
      name: 'descricao',
      label: 'Descrição',
      placeholder: 'Descreva o motivo da ouvidoria',
      component: 'FormField',
      type: 'textarea',
      rows: 4,
      colProps: { md: 6 },
      required: true,
      maxLength: 500,
      validation: { required: 'Descrição é obrigatória' },
    },
  ],
];

export const formSections = initialValues => [
  {
    title: `Detalhes do Motivo ${initialValues.nomeMotivo || ''}`,
    rows: [0],
  },
];

export const validateForm = values => {
  const errors = {};

  if (!values?.nomeMotivo || String(values.nomeMotivo).trim().length === 0) {
    errors.nomeMotivo = 'Nome do motivo é obrigatório';
  }

  if (!values?.descricao || String(values.descricao).trim().length === 0) {
    errors.descricao = 'Descrição é obrigatória';
  }

  return errors;
};
